import { Injectable, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Translations } from '../types/translation.type';
import { TRANSLATIONS_TOKEN } from './tokens/translations-token';

@Injectable({
  providedIn: 'root',
})
export class BydI18nService {
  /**
   *
   */
  private loadedTranslations: string[] = [];

  /**
   * The constructor function is used to inject the Translations object into the application.
   *
   * @param translations - this is the object that contains all the
   * translations for the app.
   * @param translate This is the service that we'll use to
   * translate the application.
   */
  constructor(@Inject(TRANSLATIONS_TOKEN) translations: Translations[], private translate: TranslateService) {
    this.translate.onLangChange.subscribe(() => {
      const language = this.translate.currentLang;
      if (!this.loadedTranslations?.includes(language)) {
        translations.forEach((translation) => {
          if (Object.keys(translation).includes(language)) {
            this.translate.setTranslation(language, translation[language], true);
          }
        });
        this.loadedTranslations.push(language);
      }
    });
  }
}
